import { usePostQuery } from '@/queries/usePostQuery';
import { Defect } from '@/types/Defecten';
import { bmsApiResponseHandler, responseToToastHandler } from '@/utils/bmsApiResponseHandlers';

import { DDPNotitie } from '../types/ddpTypes';

import usePlankTableStore from './usePlankTableStore';

const usePostNotitie = () => {
  const { post } = usePostQuery<DDPNotitie>('/ddp/notities');
  const setNotitie = usePlankTableStore((state) => state.setNotitie);
  const getDefectNotitie = usePlankTableStore((state) => state.getDefectNotitie);
  const moveDefectToOnderhoud = usePlankTableStore((state) => state.moveDefectToOnderhoud);

  /** Create a DDP Notitie and notify the user.
   *
   * @param notitie The DDP Notitie data to create.
   * @param actionKey Optional action key, to provide the right message
   * @returns DDPNotitie | null.
   */
  const putNotitie = async (notitie: DDPNotitie, actionKey = 'post-ddp-notitie') => {
    if (!notitie.opmerking) notitie.opmerking = '';
    if (!notitie.status) notitie.status = null;
    const response = (await post(notitie)) as string | null;
    const message = bmsApiResponseHandler(response, actionKey);
    responseToToastHandler(message, { autoClose: 600 });
    if (message.type !== 'success') return;
    // Notitie will be exactly the same after a request (the identifier has been given).
    setNotitie(notitie);
    return response;
  };

  const defectNaarOnderhoud = async (defect: Defect) => {
    const relatedNotitie = getDefectNotitie(defect);
    const notitie: DDPNotitie = {
      relatedTable: 'DEFECTEN',
      relatedIdentifier: defect.werkorderId ?? defect.eenheidNummer,
      status: 'NOTITIE_OP_SB_OB',
      opmerking: relatedNotitie?.opmerking ?? '',
    };
    const response = await putNotitie(notitie, 'post-ddp-notitie-status');
    if (response === null) return;
    moveDefectToOnderhoud(defect);
    return response;
  };

  return {
    putNotitie,
    defectNaarOnderhoud,
  };
};
export default usePostNotitie;
